import Page from "../Common/Page";
import { http } from "../Common/http";
import { Messages } from "../Common/ValidateMessages";
import { AuthContext } from "../Auth/Auth";
import React from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Alert,
  Space,
  Popconfirm,
  Table,
  message,
  Radio,
  Modal,
} from "antd";
import { rubricScoringPatternType } from "../Common/AppSettings";
import { NavigateFunction, Params } from "react-router-dom";
import withRouterDom from "../Common/WithReactRouterDom";
import { EvaluationViewpointRegisterButton } from "../Components/EvaluationViewpointRegisterButton";
import { ScorePatternRadioGroup } from "../Components/ScorePatternRadioGroup";
import { AuthorityButton } from "../Components/AuthorityButton";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { DetailColumns } from "./RubricPageConfig";
import { v1 as uuidv1 } from "uuid";
import TextArea from "antd/lib/input/TextArea";

const { confirm } = Modal;

interface Props {
  navigation: NavigateFunction;
  params: Readonly<Params<string>>;
}
interface RubricGetRequestBean {
  rubricId: string;
}
interface RubricBean {
  rubricId: string | undefined;
  studentCountFlag: string | undefined;
  scoringPatternType: String | undefined;
  rubricName: string | undefined;
  notes: string | undefined;
  evaluationViewpointList: EvaluationViewpointBean[];
}
export interface EvaluationViewpointBean {
  viewpointKey: string;
  evaluationViewpointId: string | undefined;
  evaluationViewpointFlag: string | undefined;
  category: string | undefined;
  subCategory: string | undefined;
  wantToAskPower: string | undefined;
  evaluationViewpointDetailList: EvaluationViewpointDetailBean[];
}
export interface EvaluationViewpointDetailBean {
  viewpointDetailKey: string;
  evaluationViewpointDetailId: string | undefined;
  evaluationCriteria: string | undefined;
  evaluationExample: string | undefined;
  lowScore: number | undefined;
  highScore: number | undefined;
}
interface ResultBean {
  result: string;
}

class RubricRegister extends React.Component<Props> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  state = {
    errorMsg: "",
    showDivId: 1,
    rubric: {
      rubricId: undefined,
      studentCountFlag: "0",
      scoringPatternType: "1",
      rubricName: undefined,
      notes: undefined,
      evaluationViewpointList: [],
    },
  };

  constructor(props: Props) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
  }

  componentDidMount = async () => {
    const { params } = this.props;

    if (params.rubricId !== undefined) {
      // 修正の場合
      try {
        this._page.current?.setState({ isPageLoading: true });
        this.setState({ errorMsg: "" });

        // backend通信し、ユーザ登録
        const postData: RubricGetRequestBean = {
          rubricId: params.rubricId,
        };
        const result = await http<RubricBean, RubricGetRequestBean>({
          path: "/Rubric/get",
          method: "post",
          body: postData,
          accessToken: this.context.accessToken,
        });
        if (result.ok) {
          this.setState({
            rubric: result.body!,
          });
          this._form.current.setFieldsValue({
            rubricName: this.state.rubric.rubricName,
            notes: this.state.rubric.notes,
          });
          this._page.current?.setState({ isPageLoading: false });
        } else {
          const errorMsg = Messages["ERR-020"];
          console.log(errorMsg);
          this.setState({ errorMsg: errorMsg });
          this._page.current?.setState({ isPageLoading: false });
        }
      } catch (error) {
        const errorMsg = Messages["ERR-020"];
        console.log(errorMsg);
        this.setState({ errorMsg: errorMsg });
        this._page.current?.setState({ isPageLoading: false });
      }
    }
  };

  // 登録画面の選択項目変更
  onChangeScoringPatternType = (newValue: any) => {
    // console.log("onChangeScoringPatternType");
    const rubric = this.state.rubric;
    rubric.scoringPatternType = newValue;
    rubric.rubricName = undefined;
    rubric.notes = undefined;
    rubric.evaluationViewpointList = [];
    this.setState({
      rubric: rubric,
    });
  };
  onChangeStucentCountFlag = (newValue: any) => {
    // console.log("onChangeStucentCountFlag");
    const rubric = this.state.rubric;
    rubric.studentCountFlag = newValue;
    rubric.scoringPatternType = "";
    this._form.current.setFieldsValue({
      scoringPatternType: undefined,
    });
    rubric.rubricName = undefined;
    rubric.notes = undefined;
    rubric.evaluationViewpointList = [];
    this.setState({
      rubric: rubric,
    });
  };
  onChangeEvaluationViewpoint = (
    evaluationViewpointIndex: number,
    newData?: any
  ) => {
    // const rubric: RubricBean = { ...this.state.rubric };
    const evaluationViewpointList: EvaluationViewpointBean[] =
      this.state.rubric.evaluationViewpointList.slice();
    const evaluationViewpoint: EvaluationViewpointBean = {
      viewpointKey:
        evaluationViewpointIndex >= 0
          ? evaluationViewpointList[evaluationViewpointIndex].viewpointKey
          : uuidv1(),
      evaluationViewpointId:
        evaluationViewpointIndex >= 0
          ? evaluationViewpointList[evaluationViewpointIndex]
              .evaluationViewpointId
          : undefined,
      evaluationViewpointFlag: newData.evaluationViewpointFlag,
      category: newData.category,
      subCategory: newData.subCategory,
      wantToAskPower: newData.wantToAskPower,
      evaluationViewpointDetailList: newData.evaluationViewpointDetailList,
    };
    if (evaluationViewpointIndex >= 0) {
      evaluationViewpointList[evaluationViewpointIndex] = evaluationViewpoint;
    } else {
      evaluationViewpointList.push(evaluationViewpoint);
    }
    // console.log(evaluationViewpointList.length);
    const rubric: RubricBean = {
      ...this.state.rubric,
      evaluationViewpointList: evaluationViewpointList,
    };

    this.setState({
      rubric: rubric,
    });
  };

  // 採点パターン選択画面の選択ボタン押す
  onClickScoringPatternTypeSelectBtn = (values: any) => {
    if (this.state.rubric.scoringPatternType === undefined) {
      message.error(Messages["ERR-042"]);
      return;
    }

    const rubric = this.state.rubric;
    rubric.rubricName = values.rubricName;
    rubric.notes = values.notes;
    this.setState({
      rubric: rubric,
      showDivId: 2,
    });
  };

  // 評価観点削除ボタン押す
  onClickEvaluationViewpointDeleteBtn = (index: number) => {
    const rubric: RubricBean = this.state.rubric;
    const evaluationViewpointList: EvaluationViewpointBean[] =
      rubric.evaluationViewpointList;
    evaluationViewpointList.splice(index, 1);
    rubric.evaluationViewpointList = [...evaluationViewpointList];
    this.setState({
      rubric: rubric,
    });
  };
  //戻るボタン押す
  onClickReturnButton = () => {
    if (
      this.state.rubric.evaluationViewpointList &&
      this.state.rubric.evaluationViewpointList !== null &&
      this.state.rubric.evaluationViewpointList.length > 0
    ) {
      confirm({
        title: Messages["CON-007"],
        icon: <ExclamationCircleOutlined />,
        okText: "はい",
        cancelText: "いいえ",
        onOk: () => {
          this.setState({
            showDivId: 1,
          });
        },
        onCancel: () => {},
      });
    } else {
      this.setState({
        showDivId: 1,
      });
    }
  };

  // 登録画面の登録ボタン押す
  onClickRegisterBtn = async (values: any) => {
    const rubric: RubricBean = this.state.rubric;
    if (
      rubric.evaluationViewpointList === null ||
      rubric.evaluationViewpointList === undefined ||
      rubric.evaluationViewpointList.length === 0
    ) {
      message.error("評価観点" + Messages["ERR-041"]);
      return;
    }

    confirm({
      title: Messages["CON-031"],
      icon: <ExclamationCircleOutlined />,
      onOk: () => {
        this.doSave(rubric);
      },
      onCancel: () => {},
      okText: "はい",
      cancelText: "いいえ",
    });
  };

  doSave = async (rubric: RubricBean) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({ errorMsg: "" });

      // backend通信し、ユーザ登録
      const result = await http<ResultBean, RubricBean>({
        path: "/Rubric/save",
        method: "post",
        body: rubric,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        // 保存成功
        this._page.current?.setState({ isPageLoading: false });
        // 完了画面表示
        this.setState({ errorMsg: "", showDivId: 3 });
      } else {
        // 失敗
        const errorMsg = Messages["ERR-020"];
        console.log(errorMsg);
        this.setState({ errorMsg: errorMsg });
        this._page.current?.setState({ isPageLoading: false });
      }
    } catch (error) {
      // エラー
      const errorMsg = Messages["ERR-020"];
      console.log(errorMsg);
      this.setState({ errorMsg: errorMsg });
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  columns = [
    {
      title: <div className="table-title">カテゴリ</div>,
      key: "category",
      width: 300,
      render: (text: any, record: any, index: number) => {
        if (record.category) return record.category;
        else return "-";
      },
    },
    {
      title: <div className="table-title">サブカテゴリ</div>,
      key: "subCategory",
      width: 300,
      render: (text: any, record: any, index: number) => {
        if (record.subCategory) return record.subCategory;
        else return "-";
      },
    },
    {
      title: <div className="table-title">問いたい力</div>,
      key: "wantToAskPower",
      width: 300,
      render: (text: any, record: any, index: number) => {
        if (record.wantToAskPower) return record.wantToAskPower;
        else return "-";
      },
    },
    {
      title: "",
      key: "action",
      render: (text: any, record: any, index: number) => (
        <Space size="middle" direction="horizontal">
          <Popconfirm
            title={Messages["CON-001"]}
            okText="はい"
            cancelText="いいえ"
            onConfirm={() => this.onClickEvaluationViewpointDeleteBtn(index)}
          >
            <Button type="primary" htmlType="button">
              削除
            </Button>
          </Popconfirm>
          <EvaluationViewpointRegisterButton
            width={50}
            label="編集"
            evaluationViewpoint={
              this.state.rubric.evaluationViewpointList[index]
            }
            scoringPatternType={this.state.rubric.scoringPatternType}
            onChange={(newData) =>
              this.onChangeEvaluationViewpoint(index, newData)
            }
          />
        </Space>
      ),
    },
  ];

  expandedRowRender = (viewpointRecored: EvaluationViewpointBean) => {
    // console.log(viewpointRecored);
    return (
      <Table
        rowKey={(record: EvaluationViewpointDetailBean) =>
          record.viewpointDetailKey
        }
        scroll={{ x: 800 }}
        bordered
        columns={DetailColumns[this.state.rubric.scoringPatternType]}
        dataSource={viewpointRecored.evaluationViewpointDetailList}
        pagination={false}
      />
    );
  };

  render(): React.ReactNode {
    return (
      <Page title="ルーブリック登録/修正" ref={this._page}>
        <div
          style={{
            margin: "20px",
            display: this.state.errorMsg !== "" ? "block" : "none",
          }}
        >
          <Alert
            type="error"
            description={this.state.errorMsg}
            message="エラー"
            closable
          />
        </div>

        <div
          style={{
            margin: "20px",
            display: this.state.showDivId === 1 ? "block" : "none",
          }}
        >
          <div style={{ margin: "15px" }}>
            <Form
              colon={false}
              labelCol={{ span: 3 }}
              layout="horizontal"
              labelAlign="left"
              name="userEdit"
              labelWrap={true}
              onFinish={this.onClickScoringPatternTypeSelectBtn}
              className="user-form"
              ref={this._form}
              initialValues={{
                scoringPatternType: this.state.rubric.scoringPatternType,
                studentCount: this.state.rubric.studentCountFlag,
              }}
              fields={[
                {
                  name: "scoringPatternType",
                  value: this.state.rubric.scoringPatternType,
                },
                {
                  name: "studentCount",
                  value: this.state.rubric.studentCountFlag,
                },
              ]}
            >
              <Row>
                <Col>
                  <span>
                    ルーブリック名の入力、採点パターンの指定を行ってください。
                    <br />
                    ※登録済データの採点パターンを変更すると、以前に登録された内容はクリア（最初から登録し直し）となります。
                  </span>
                </Col>
              </Row>
              <Row style={{ marginTop: "20px" }}>
                <Col span={23}>
                  <Form.Item
                    label="ルーブリック名"
                    name="rubricName"
                    rules={[{ required: true, whitespace: true }, { max: 30 }]}
                  >
                    <Input style={{ width: "500px" }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginTop: "20px" }}>
                <Col span={23}>
                  <Form.Item
                    label="　注意事項"
                    name="notes"
                    rules={[{ whitespace: true }, { max: 1024 }]}
                  >
                    <TextArea
                      rows={3}
                      maxLength={1024}
                      style={{ width: "500px" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={23}>
                  <Form.Item
                    label="採点対象人数"
                    name="studentCount"
                    rules={[{ required: true }]}
                  >
                    <Radio.Group
                      onChange={(e) =>
                        this.onChangeStucentCountFlag(e.target.value)
                      }
                    >
                      <Radio value={"0"}>１人</Radio>
                      <Radio value={"1"}>複数人</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={23}>
                  <Form.Item
                    label="採点パターン"
                    name="scoringPatternType"
                    rules={[{ required: true }]}
                  >
                    <ScorePatternRadioGroup
                      onChange={this.onChangeScoringPatternType}
                      haveEvaluationViewpoints={
                        this.state.rubric.evaluationViewpointList &&
                        this.state.rubric.evaluationViewpointList !== null &&
                        this.state.rubric.evaluationViewpointList.length > 0
                      }
                      studentCount={this.state.rubric.studentCountFlag}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginTop: "20px" }}>
                <Col span={15} offset={3}>
                  ※ダブルクリックをすると採点パターンの確認ができます
                </Col>
                <Col span={4}>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100px" }}
                    >
                      選択
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
        <div
          style={{
            margin: "20px",
            display: this.state.showDivId === 2 ? "block" : "none",
          }}
        >
          <Row>
            <Col>ルーブリック名：</Col>
            <Col>{this.state.rubric.rubricName}</Col>
          </Row>
          <Row>
            <Col>採点パターン：</Col>
            <Col>
              ({this.state.rubric.scoringPatternType!})
              {rubricScoringPatternType[this.state.rubric.scoringPatternType!]}
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>[評価観点]</Row>
          <Row style={{ marginTop: "20px" }}>
            <EvaluationViewpointRegisterButton
              scoringPatternType={this.state.rubric.scoringPatternType}
              onChange={(newData) =>
                this.onChangeEvaluationViewpoint(-1, newData)
              }
            />
          </Row>

          <Table
            rowKey={(record: EvaluationViewpointBean) => record.viewpointKey}
            bordered
            columns={this.columns}
            dataSource={this.state.rubric.evaluationViewpointList}
            scroll={{ y: 800 }}
            pagination={false}
            expandable={{
              expandedRowRender: (record) => this.expandedRowRender(record),
              // onExpand: (expanded, record) => {
              //   console.log("expanded:" + expanded);
              //   console.log(record);
              // },
            }}
          />
          <Row style={{ marginTop: "20px", marginLeft: "10px" }}>
            <Col offset={15} span={3}>
              <Button
                type="primary"
                htmlType="button"
                onClick={this.onClickReturnButton}
                style={{ width: "100px" }}
              >
                戻る
              </Button>
            </Col>
            <Col>
              <AuthorityButton
                functioncode="FU-62"
                authority="2"
                type="primary"
                htmlType="button"
                onClick={this.onClickRegisterBtn}
                style={{ width: "100px" }}
              >
                登録
              </AuthorityButton>
            </Col>
          </Row>
        </div>
        <div
          style={{
            margin: "20px",
            display: this.state.showDivId === 3 ? "block" : "none",
          }}
        >
          <div>ルーブリック登録・修正は完了しました。</div>
          <div style={{ margin: "20px" }}>
            <Row style={{ marginTop: "10px", marginLeft: "10px" }}>
              <Col span={5}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => {
                    const { navigation } = this.props;
                    navigation("/RubricList");
                  }}
                >
                  ルーブリック一覧へ
                </Button>
              </Col>
              <Col span={5}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => {
                    const { navigation } = this.props;
                    navigation("/RubricRegister");
                    this.setState({
                      errorMsg: "",
                      showDivId: 1,
                      rubric: {
                        rubricId: undefined,
                        studentCountFlag: "0",
                        scoringPatternType: "1",
                        rubricName: undefined,
                        notes: undefined,
                        evaluationViewpointList: [],
                      },
                    });
                    this._form.current.resetFields();
                  }}
                >
                  続けて登録
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Page>
    );
  }
}

export default withRouterDom(RubricRegister);
